import { pickLiveOrPreliveId, prepareEmptyMarket, mapMarketName } from "../../helpers";
export const getMarketsAmerican = (marketsInConfig, markets, event, dict) => {
    const marketNames = [];
    const marketsToDisplay = marketsInConfig.map((config, index) => {
        const market = markets.find(market => market.marketType.id === pickLiveOrPreliveId(config, event.isLive));
        marketNames.push(mapMarketName(config, dict, event.sportId)[0]);
        return market
            ? market
            : prepareEmptyMarket(event.id, config.template, index);
    });
    return {
        markets: marketsToDisplay,
        names: marketNames
    };
};
//# sourceMappingURL=getMarketsAmerican.js.map